import React from "react";
import BuyerList from "./BuyerList";

const Buyer = () => <BuyerList />;

export default Buyer;
